export const portalSections = [
    {
      id: 'all-you-need',
      title: 'HOME_PAGE.HEADER_FOOTER.MOBILITY_MARKETPLACE',
      body: 'HOME_PAGE.ALL_YOU_NEED.BODY',
      button: 'HOME_PAGE.ALL_YOU_NEED.BUTTON_TEXT',
      redirectionUrl: '/about-us',
      target: '',
      reactGAEvents: {
        category: 'Know More',
        action: 'User Clicked on Know More',
        label: 'Know More'
      }
    },
    {
      id: 'mps-redirection',
      title: 'HOME_PAGE.MPS_WEBSITE_SECTION.TITLE',
      body: 'HOME_PAGE.MPS_WEBSITE_SECTION.BODY',
      button: 'HOME_PAGE.MPS_WEBSITE_SECTION.BUTTON_TEXT',
      redirectionUrl: 'https://dev.bosch-mps.com/',
      target: '_blank',
      reactGAEvents: {
        category: 'Go To MPS',
        action: 'User Clicked on Go To MPS',
        label: 'Go To MPS'
      }
    }
  ];
